import React, { Component } from 'react'
import Head from '../../components/head/'
import { Button, Icon } from 'antd';
import businessQuitTime from '../../utils/businessQuitTime'

// redux
import { connect } from 'react-redux';
import * as inpatientAction from '../../store/actions/inpatient'

/*
 * 住院信息
 */
class HcPatientInfo extends Component {
  constructor(props){
    super(props);
    this.state = {
      patientInfo: {}
    };
  }

  goHomePage(){
    this.props.history.push('/')
  }
  goUpPage(){
    this.props.history.push('/inpatientCost')
  }

  componentDidMount(){
    this.setState({
      patientInfo: this.props.inpatient.patientInfo,
    })
  }

  depositConst(){
    this.props.history.push('/inpatientList')
  }  

  render() {
    const quitTime = businessQuitTime.inpatientCost.hcPatientInfo;
    const { patientInfo } = this.state;
    const { NAME, SEX, SE_NAME, SB_NO, SA_CODE, COST, TOTAL_FEE, DEPOSIT } = patientInfo;

    return (
      <div>
        <Head quitTime={quitTime} />
            
        <div className="context-container clearfix">
          <h3 className="business-name">住院查询 - 患者信息</h3>
          <div className="par-info">
            <p>
              <em>患者姓名</em>
              <i>{ NAME }</i>
            </p>
            <p>
              <em>姓别</em>
              <i>{ SEX === '2' ? '女' : '男' }</i>
            </p>
            <p>
              <em>科室名称</em>
              <i>{ SE_NAME }</i>
            </p>
            <p>
              <em>床位号</em>
              <i>{ SB_NO }</i>
            </p>
            <p>
              <em>病区号</em>
              <i>{ SA_CODE }</i>
            </p>
            <p>
              <em>已交押金总额</em>
              <i>{ DEPOSIT }</i>
            </p>
            <p>
              <em>住院费用额</em>
              <i>{ TOTAL_FEE }</i>
            </p>
            <p>
              <em>住院押金余额</em>
              <i>{ COST }元</i>
            </p>
            <div>
              <Button type="primary" size="large" onClick={this.depositConst.bind(this)} style={{width: "500px", backgroundColor: "#00bd58", border: "1px #00bd58 solid", marginTop: "20px"}}>确  定</Button>
            </div>
          </div>
        </div>
        
        <div className="footer">
          <Button type="primary" size="large" onClick={this.goUpPage.bind(this)} className="left">
            <Icon type="left" />上一步</Button>
          <Button type="primary" size="large" onClick={this.goHomePage.bind(this)}
            style={{ "backgroundColor": "#f76e6e", border: "1px #f76e6e solid", "float": "right"}}>
            <Icon type="poweroff" theme="outlined" />退 出</Button>
          <div className="address"></div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    inpatient: state.inpatient,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addInpatient: (data) => {
      dispatch(inpatientAction.addInpatient(data));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HcPatientInfo)